module.exports = __webpack_public_path__ + "img/newsImg.14e1bee8.png";